'use strict'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import { LOGOUT } from '@/store/mutation-types'

// start axios
function setupHttpClient (store) {
  // Set defaults
  axios.defaults.baseURL = '/api/v1'
  axios.defaults.headers.common['X-Client'] = 'vandacare'

  // Set interceptor for request
  axios.interceptors.request.use(cfg => {
    // only if content type not specified
    if (cfg.headers['Content-Type'] === '') {
      cfg.headers['Content-Type'] = 'application/json'
    }

    if (store.getters.authorized) {
      const token = store.getters.token
      cfg.headers.Authorization = `Bearer ${token.accessToken}`
    }

    return cfg
  })

  // Set interceptor for response
  axios.interceptors.response.use(response => {
    if (response) {
      switch (response.status) {
        // Unauthorized
        case 401:
          store.commit(LOGOUT)
          break
        default:
          break
      }
    }
    return Promise.resolve(response)
  },
  error => {
    // redirect to login if unauthorized response
    if (error.response) {
      const result = error.response.data
      switch (error.response.status) {
        // Unauthorized
        case 401:
          store.commit(LOGOUT)
          break
          // Forbidden
        case 403:
          // store.dispatch('showToast', 'No any permission to access this page/function');
          return Promise.reject(result.error.message)
        case 400:
          if (result.error.errors) {
            const meta = []
            result.errors.forEach(v => {
              meta.push(v.message)
            })

            if (meta.length > 0) {
              return Promise.reject(meta.join('\n'))
            } else {
              return Promise.reject(result.error.message)
            }
          } else {
            return Promise.reject(result.error.message)
          }
        default:
          break
      }
      return Promise.reject(result.error.message)
    }
    return Promise.reject(error)
  })
}
// end axios

// start filter
function setupFilter () {
  // date format filter
  Vue.filter('date', (value, df = 'DD/MMM/YYYY') => {
    if (value) {
      return moment(value).format(df)
    } else {
      return ''
    }
  })
  // date time format filter
  Vue.filter('dateTime', (value, df = 'DD/MMM/YYYY HH:mm') => {
    if (value) {
      return moment(value).format(df)
    } else {
      return ''
    }
  })
  // time format filter
  Vue.filter('time', (value, df = 'HH:mm') => {
    if (value) {
      return moment(value).format(df)
    } else {
      return ''
    }
  })
}
// end filter

export default class Config {
  static init (store) {
    setupHttpClient(store)
    setupFilter()
    Vue.prototype.$http = axios
    Vue.prototype.$moment = moment
  }
}
